var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-menu", {
    attrs: { "close-on-content-click": false },
    scopedSlots: _vm._u(
      [
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.accession.startsWith("MGYP")
                      ? "https://esmatlas.com/resources/detail/" + _vm.accession
                      : "https://www.uniprot.org/uniprotkb/" + _vm.accession,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [
                  _vm.$slots["accession"]
                    ? _vm._t("accession")
                    : [_vm._v(_vm._s(_vm.accession))],
                ],
                2
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }